import { connect } from 'react-redux';

import { Creators } from 'services/redux/buyVignette/actions';
import AnnualPaymentChoice from './components';

const mapStateToProps = state => {
  return {
    isGettingVignetCost: state.buyVignet.isGettingVignetCost,
    vignetCostError: state.buyVignet.vignetCostError,
    vignetCost: state.buyVignet.vignetCost,
    isGettingInstallment: state.buyVignet.isGettingInstallment,
    installmentError: state.buyVignet.installmentError,
    installment: state.buyVignet.installments,
    creatingInstallment: state.buyVignet.creatingInstallment,
    creatingDirect: state.buyVignet.creatingDirect,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getInstallmentData: () => {
      dispatch(Creators.buyVignetGetInstallmentsRequest());
    },
    getVignetCost: () => {
      dispatch(Creators.buyVignetGetVignetCostRequest());
    },
    createInstallment: () => {
      dispatch(Creators.buyVignetCreateInstallmentRequest());
    },
    createDirect: data => {
      dispatch(Creators.buyVignetCreateDirectRequest());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AnnualPaymentChoice);
